<template>
    <div>
        <v-menu>    
            <template v-slot:activator="{ on }">  
                <v-toolbar-title class="profile">
                    <span class="name hidden-sm-and-down">
                        {{ name }}       
                    </span> 
                    <v-btn icon v-on="on">
                        <v-icon>person</v-icon>
                    </v-btn>        
                </v-toolbar-title>
            </template>
            <v-list>
                <v-list-item @click="signOut">
                    <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>    
    </div>   
</template>

<script>
import util from '@/helpers/util';

export default {
    name: 'Profile',
    computed: {
        name: function () {
            return util.getUserProfileNameFromUserObject(this.$store.state.authStore.user);
        },
    },
    methods: {
        signOut () {
            this.$router.push({
                path: "/logout"
            });
        }
    }
}
</script>

<style scoped>
.name {
    font-size: 11pt;
}
</style>